import React from 'react';
import { Flex, IconButton, TextV2 } from '@withjoy/joykit';
import { ProgressBar } from '../../../../../ProgressBar';
import { CustomCard as EditIcon } from '@withjoy/joykit/icons';
import { pxToRem } from '@withjoy/joykit/theme';
import { useTranslation } from '@shared/core';
import { useRegistryGiftCounts } from '@apps/registry/common/components/RegistryGiftCounts/RegistryGiftCounts.controller';

interface CountsSummaryProps {
  completionCountTitle: ReturnType<typeof useRegistryGiftCounts>['completionCountTitle'];
  completionPercent: ReturnType<typeof useRegistryGiftCounts>['completionPercent'];
  formattedCompletionPercent: ReturnType<typeof useRegistryGiftCounts>['formattedCompletionPercent'];
  handleOnEditClick: ReturnType<typeof useRegistryGiftCounts>['handleOnEditClick'];
}

export const CountsSummary = ({ completionCountTitle, completionPercent, formattedCompletionPercent, handleOnEditClick }: CountsSummaryProps) => {
  const { t } = useTranslation('sharedComponents');
  const { ariaEditLabel } = t('registryGiftCounts');

  return (
    <>
      <Flex justifyContent="space-between">
        <Flex marginBottom={3}>
          <TextV2 typographyVariant="body1" marginRight={3}>
            {completionCountTitle}
          </TextV2>
          <IconButton minWidth={pxToRem(22)} height={pxToRem(22)} color="mono14" variant="ghost" aria-label={ariaEditLabel()} onClick={handleOnEditClick}>
            <EditIcon />
          </IconButton>
        </Flex>
        <TextV2 color="mono12" typographyVariant="label2">{`${formattedCompletionPercent}%`}</TextV2>
      </Flex>
      <ProgressBar height={16} progressPercentage={completionPercent} />
    </>
  );
};
